var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.havePermission)?_c('div',{staticClass:"assess"},[_c('section',[_c('div',{staticClass:"al_container"},[_c('breadcrumb')],1)]),_c('section',[_c('div',{staticClass:"al_container"},[_c('router-view')],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }